import React, { useContext } from "react";
import styled from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { EventContext, AnalyticsContext } from "Components";
import { MaxWidthContainer } from "Routes/Root/Components/Layout";
import { fonts } from "theme/fonts";
import { useLocation } from "react-router-dom";

export const BrandAd = ({ headingBorder }) => {
  const { event } = useContext(EventContext);
  const { logClick } = useContext(AnalyticsContext);

  const { heading, body, btnText, utmStrings } = event.callToActions.brand;

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmCampaign = params.get("utm_campaign");

  let utmString = utmStrings.find((source) => source.code === utmCampaign);
  if (!utmString)
    utmString = utmStrings.find((source) => source.code === "default");

  const adClickHandler = () => {
    logClick({
      label: "Brand Ad",
      url: utmString.link,
    });
  };

  return (
    <Wrapper>
      <Container headingBorder={headingBorder}>
        <h2>{ReactHtmlParser(heading)}</h2>
        <p>{ReactHtmlParser(body)}</p>
        <a
          href={utmString.link}
          onClick={adClickHandler}
          target="_blank"
          rel="noopener noreferrer"
        >
          {btnText}
        </a>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

const Container = styled(MaxWidthContainer)`
  color: #ffffff;
  padding: 35px 15px;

  h2 {
    text-transform: uppercase;
    line-height: 1.25;

    ${(props) =>
      props.headingBorder &&
      `
      border-left: 6px solid #B00D25;
      padding-left: 15px;
    `}
  }

  a {
    display: inline-block;
    color: #ffffff;
    padding: 15px 35px;
    text-decoration: none;
    font-family: ${fonts.header};
    text-transform: uppercase;
    border: 4px solid #b42b36;
    letter-spacing: 2px;
  }

  a:hover,
  a:focus {
    background-color: #b42b36;
  }

  @media only screen and ${(props) => props.theme.maxMedia.medium} {
    padding: 50px 25px;
  }
`;
